import { render } from "./LockDesignerProducts.vue?vue&type=template&id=4bdeabf4&ts=true"
import script from "./LockDesignerProducts.vue?vue&type=script&lang=ts"
export * from "./LockDesignerProducts.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__